import React from 'react'
import clsx from 'clsx'
import { Sparkles } from 'lucide-react'
import { TONE } from './_shared'

/**
 * Reusable tone-mapped tile grid — shared by Philosophy pillars and
 * ROI systems.  Same visual language as launch-platform/FeatureGrid.
 */
export default function FeatureGrid({ items, icons, cols = 3 }) {
  return (
    <div className={clsx(
      'grid gap-3 md:gap-4',
      cols === 2 && 'grid-cols-1 sm:grid-cols-2',
      cols === 3 && 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
      cols === 4 && 'grid-cols-2 sm:grid-cols-2 lg:grid-cols-4',
      cols === 5 && 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5',
    )}>
      {items.map((i) => {
        const tone = TONE[i.tone] || TONE.orange
        const Icon = icons[i.iconKey] || Sparkles
        return (
          <div key={i.id} className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl transition-all hover:border-white/20 hover:bg-white/[0.03] hover:-translate-y-[1px] overflow-hidden">
            <div className="pointer-events-none absolute inset-0 opacity-40"
              style={{ background: `radial-gradient(80% 40% at 20% 0%, rgba(${tone.rgb},0.10), transparent 70%)` }} />
            <div className="relative flex flex-col gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border"
                style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.08)`, color: tone.hex }}>
                <Icon strokeWidth={1.8} style={{ width: 18, height: 18 }} />
              </span>
              <div>
                <h4 className="text-[14.5px] font-semibold text-white leading-tight">{i.label}</h4>
                {i.body && <p className="text-[13px] text-zinc-400 leading-relaxed mt-1.5">{i.body}</p>}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
